<template>
  <el-form
    ref="form"
    class="search-form"
    label-position="top"
    @submit.native.prevent="submit"
  >
    <div class="card form-card">
      <div class="form-group">
        <label for="zendeskTicketId">{{
          $t("messages.zendesk-ticket-id")
        }}</label>
        <div class="row">
          <div class="col-12">
            <input
              id="zendeskTicketId"
              v-model="input.zendeskTicketId"
              type="text"
              class="form-control"
              :placeholder="'Id de ticket en Zendesk (Ej: 1777008)'"
              required
              aria-required="true"
            />
            <div class="help-block text-right">&nbsp;</div>
          </div>
          <div class="col-12 mt-4">
            <button class="btn btn-block btn-danger">
              {{ $t("messages.solicitar") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </el-form>
</template>
<script>
export default {
  props: {
    latamId: { type: String, required: true }
  },
  data() {
    return {
      input: {
        zendeskTicketId: ""
      }
    };
  },
  methods: {
    submit() {
      window.location.href = `callcenter/${this.latamId}/ola?zendesk-ticket-id=${this.input.zendeskTicketId}`;
    }
  }
};
</script>